export default __webpack_public_path__ + "static/media/dollar.897b0f8a.svg";